import * as z from "zod";

export const templateSchema = z.object({
  id: z.string(),
  organizationId: z.string(),
  name: z.string(),
  fileKey: z.string(),
  version: z.number(),
  requiredHeadings: z.string().nullish(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});

export const listTemplatesInputSchema = z.object({
  organizationId: z.string(),
});

export type ListTemplatesInput = z.infer<typeof listTemplatesInputSchema>;

export const listTemplatesResponseSchema = z.object({
  templates: z.array(templateSchema),
});

export type ListTemplatesResponse = z.infer<typeof listTemplatesResponseSchema>;

export const createTemplateInputSchema = z.object({
  organizationId: z.string(),
  name: z.string().min(1),
  fileKey: z.string().min(1),
  requiredHeadings: z.string().optional(),
});

export type CreateTemplateInput = z.infer<typeof createTemplateInputSchema>;

export const createTemplateResponseSchema = z.object({
  template: templateSchema,
});

export type CreateTemplateResponse = z.infer<typeof createTemplateResponseSchema>;
